import { createActions, createReducer } from 'reduxsauce'
import BuscarPesquisaService from '~/modulos/basico/servicos/BuscarPesquisaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaBuscarPesquisaInicio: [],
    buscaBuscarPesquisaSucesso: ['buscarPesquisa'],
    buscaBuscarPesquisaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaBuscarPesquisa = filtro => {
    return dispatch => {
        dispatch(Creators.buscaBuscarPesquisaInicio())
        let serv = new BuscarPesquisaService()
        return serv
            .getPesquisar(filtro)
            .then(response => dispatch(Creators.buscaBuscarPesquisaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaBuscarPesquisaErro(error)))
    }
}

const buscaBuscarPesquisaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaBuscarPesquisaSucesso = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaBuscarPesquisaErro = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.buscarPesquisa, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_BUSCAR_PESQUISA_INICIO]: buscaBuscarPesquisaInicio,
    [Types.BUSCA_BUSCAR_PESQUISA_ERRO]: buscaBuscarPesquisaSucesso,
    [Types.BUSCA_BUSCAR_PESQUISA_SUCESSO]: buscaBuscarPesquisaErro,
})
